import React from 'react'
import { InviteBoxContext } from './context'
import { InviteBoxControllerProps } from './types'
import { useApp } from '../../hooks/app'
import { MemberProfileType } from '../../types/member_profile_type'

export const InviteBoxController = (
  props: InviteBoxControllerProps
): JSX.Element => {
  const { user } = useApp()
  const [accepting, setAccepting] = React.useState<boolean>(false)
  const [declining, setDeclining] = React.useState<boolean>(false)

  const invites = React.useMemo(() => {
    const draft: Array<MemberProfileType> = []
    // push pending organization invites
    for (const member of user?.member_organizations || []) {
      if (member.status === 'PENDING') {
        draft.push({
          kind: 'organization',
          key: `organization::${member.organization_id}`,
          label: member?.organization?.name || 'unknown',
          value: member,
        })
      }
    }
    // push pending sellers invites
    for (const member of user?.member_sellers || []) {
      if (member.status === 'PENDING') {
        draft.push({
          kind: 'seller',
          key: `seller::${member.organization_id}`,
          label: member.organization?.name || 'unknown',
          value: member,
        })
      }
    }
    // return draft invites
    return draft
  }, [user])

  const state = {
    invites,
    accepting,
    declining,
    setAccepting,
    setDeclining,
  }

  return (
    <InviteBoxContext.Provider value={state}>
      {props.children}
    </InviteBoxContext.Provider>
  )
}
